import { render } from "./ContractorLogin.vue?vue&type=template&id=2ec72df0"
import script from "./ContractorLogin.vue?vue&type=script&lang=js"
export * from "./ContractorLogin.vue?vue&type=script&lang=js"

import "./ContractorLogin.vue?vue&type=style&index=0&id=2ec72df0&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__